/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable arrow-body-style */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
/* eslint-disable react/button-has-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Box, Typography, Tooltip, Button, IconButton, Tabs, Tab, Grid, Paper, Card, Accordion, AccordionSummary, AccordionDetails, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ChevronDown } from "lucide-react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format, parse } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import customParseFormat from "dayjs/plugin/customParseFormat";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { CheckCircleIcon, GlobeAltIcon, VideoCameraIcon, UsersIcon } from "@heroicons/react/24/outline";
import './index.css';
import { getIndividualResultForSat, getSatDetails } from '../../../Redux/Action'
import LinearAssessment from './linearassessment';
import AdaptiveAssessment from './adaptiveassessment';
import adminServices from '../../../services/adminServices';
import trialAndStripeSubscriptionService from '../../../services/trialAndStripeSubscriptionService'
import { ComingFrom, FromGeneralAssessmentView, ComingFromSub, languagecodevalue, openSnackbar } from '../../../store/reducer';
import assessmentMaintainance from '../../../assets/Images/assessment_under_maintenance.png'
import analysisNotAttempted from '../../../assets/Images/attemptTheAttemptImage.png'
import fullCover from '../../../assets/Images/full_test_SAT.jpg'
import subjectCover from '../../../assets/Images/subject_test_SAT.jpg'
import FlashcardFab from '../course/FlashcardFab';
import AssessmentSkeleton from "../../../components/loaders/AssessmentSkeleton";
import AnalyticsSkeleton from '../../../components/loaders/AnalyticsSkeleton';
import { ScoreCardAnalytics, PacingAnalysis, ScoreProgression, QuestionWiseAnalysis } from './assessmentanalytics'
import AssessmentScore from './assessment_score'
import ChapterMastery from './ChapterMastery'
import AttemptDropdown from './dropdown'
// import AssessmentCompleteDialog from '../../../components/AssessmentCompleteDialog'

dayjs.extend(isBetween);
dayjs.extend(customParseFormat);


const AssessmentOverview = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const allassessmentdetails = useSelector((state) => state);
    const [visibleTabs, setvisibleTabs] = useState([])
    const [activeTabs, setActiveTabs] = useState('0');
    const [pageLoading, setPageLoading] = useState(true);
    const userid = useSelector((state) => state.userInfo && state.userInfo.id);
    const userdetails = useSelector((state) => state.userInfo);
    const [selectedAttemptIndex, setSelectedAttemptIndex] = useState(0);

    const [currency, setCurrency] = React.useState(allassessmentdetails?.userInfo?.currencyType ? allassessmentdetails?.userInfo?.currencyType.code : 'USD');
    const [value, setValue] = useState(0);
    const [assessmentDetails, setAssessmentDetails] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [view, setView] = useState(allassessmentdetails?.GetSatIndividualDetails)
    const [assessmentView, setAssessmentView] = useState(false);
    const [analysis, setAnalysis] = useState([]);
    const [allQuestions, setAllQuestions] = useState([]);
    const [chapterMastery, setChapterMastery] = useState([]);

    const getSatAssessmentDetails = () => {
        try {
            const stored = localStorage.getItem('assess_details');
            return stored ? JSON.parse(stored) : null;
        } catch {
            return null;
        }
    };
    const [assessmentdetails1, setAssessmentDetails1] = useState(() => {
        if (location.state?.data) {
            return location.state.data;
        }
        return getSatAssessmentDetails()?.data || null;
    });

    const [isLoading, setIsLoading] = useState(false);
    const [analysisTestScore, setAnalysisTestScore] = useState(null);
    const [name, setName] = useState(0);
    const [attemptCount, setAttemptCount] = useState(0);
    const [resumeLength, setResumeLength] = useState(0);
    const questionAnalysisRef = useRef(null);
    const [comingFrom, setComingFrom] = useState('');
    const [fromIndex, setFromIndex] = useState(0);
    const [resumeData, setResumeData] = useState([]);
    const [assessmentTabIndex, setAssessmentTabIndex] = useState(0);
    // Shown once the user finishes an exam and lands back on this overview.
    const [showExamCompleteDialog, setShowExamCompleteDialog] = useState(false);
    const [syllabusOpen, setSyllabusOpen] = useState(true);

    const userRole = useSelector((state) => state.userInfo && state.userInfo.role);
    const { assessmentId: paramAssessmentId } = useParams();
    const [assessmentid, setAssessmentId] = useState(paramAssessmentId);
    const [maintainanceView, setMaintainanceView] = useState(false)

    useEffect(() => {
        setSyllabusOpen((assessmentdetails1?.display_config?.syllabus?.length || 0) > 0);
    }, [assessmentdetails1]);
    
    const CallBackAssessmentView = (fromindex, tab, tabIndex, data) => {

        if (data === 'back') {
            setAssessmentTabIndex(1);
        }
        else {
            setAssessmentTabIndex(2);
        }
        // `data === 'exam'` means the exam was just submitted — show the
        // completion popup now that we're back on the overview page.
        if (data === 'exam') {
            setShowExamCompleteDialog(true);
        }
        getAnalysis(fromIndex);
        getAnalysisTestScore(fromIndex, assessmentdetails1?.assessment_pattern_name)
        setValue(0);
        setAllQuestions([]);
        setFromIndex(fromIndex);
        setSelectedAttemptIndex(fromIndex);

        setAssessmentView(false);
        loadInitialData();


    }

    useEffect(() => {
        if (assessmentDetails?.assessmentDetails) {
            setAssessmentDetails1(assessmentDetails.assessmentDetails);
            setAttemptCount(assessmentDetails.attempts?.length)
        }
    }, [assessmentDetails]);

    const isAssessmentFree = assessmentdetails1?.is_payment === false && assessmentdetails1?.ispaid === false;
    const loadInitialData = async () => {
        setPageLoading(true);
        try {
            if (!assessmentid || !userid) return;
            await dispatch(getIndividualResultForSat(userid, assessmentid, assessmentdetails1?.assessment_pattern_name
            ));
            await new Promise(resolve => setTimeout(resolve, 500));
        } catch (error) {
            console.error('Error loading data:', error);
        } finally {
            setPageLoading(false);
        }
    };

    useEffect(() => {
        loadInitialData();
    }, [assessmentid, userid]);


    useEffect(() => {
        setAssessmentDetails(allassessmentdetails?.GetSatIndividualDetails)
    }, [allassessmentdetails])

    useEffect(() => {
        if (assessmentView === true) {
            window.scrollTo({ top: 0, behavior: 'instant' });
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
        } else {
            document.body.style.overflow = 'auto';
            document.documentElement.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
        }
    }, [assessmentView]);

    // Safety net: the exam flow (linear/adaptive congrats <Dialog>, and any
    // other MUI modal that gets unmounted while still open) can leave the
    // page scroll-locked — `body { overflow: hidden; padding-right: … }`.
    // Whenever we're on the overview with no modal of our own open, and on
    // unmount, force the document scroll back so the page is usable.
    useEffect(() => {
        if (showExamCompleteDialog || assessmentView === true) return undefined;
        const restoreScroll = () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.body.style.removeProperty('padding-right');
        };
        restoreScroll();
        // Run once more after any in-flight MUI dialog close-transition
        // (~225ms) so we win the race against its scroll-lock teardown.
        const t = setTimeout(restoreScroll, 400);
        return () => { clearTimeout(t); restoreScroll(); };
    }, [showExamCompleteDialog, assessmentView]);

    useEffect(() => {
        if (assessmentDetails?.assessmentDetails) {
            setAssessmentDetails1(assessmentDetails.assessmentDetails);
            if (assessmentid) {
                localStorage.setItem('sat_assess_details', JSON.stringify({
                    assessmentId: assessmentid,
                    data: assessmentDetails.assessmentDetails
                }));
            }
        }
    }, [assessmentDetails, assessmentid]);


    useEffect(() => {
        return () => {
            const currentPath = window.location.pathname;
            if (!currentPath.includes('/sat') && !currentPath.includes('/SAT')) {
                localStorage.removeItem('sat_assess_details');
            }
        };
    }, []);

    useEffect(() => {
        const handleBeforeUnload = () => {
            dispatch(FromGeneralAssessmentView(false));
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        const handlePopState = () => {
            dispatch(FromGeneralAssessmentView(false));
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    const handleTabChangeTabs = (event, newValue) => {
        const index = visibleTabs.findIndex((tab) => tab.id === newValue);
        setAllQuestions(analysis && analysis?.length > 0 && analysis[index]?.questions)
        setName(index);
        setActiveTabs(newValue);
    };
    const selectedAttemptRecords = assessmentDetails?.attempts?.[selectedAttemptIndex]?.records || [];
    const selectedAttemptUserResultLength = selectedAttemptRecords?.[0]?.user_result?.length || 0;
    const requiredUserResultLength = assessmentdetails1?.assessment_type !== 'Full Test' ? 2 : 4;
    const isSelectedAttemptCompleted = selectedAttemptRecords.length > 0 && selectedAttemptUserResultLength >= requiredUserResultLength;


    const rawFrom = location?.state?.data?.user_message?.fromDate;
    const rawTo = location?.state?.data?.user_message?.toDate;
    const INPUT_FORMAT = "dd/MM/yyyy hh:mm:ss a";
    const from = rawFrom ? format(parse(rawFrom, INPUT_FORMAT, new Date()), "dd-MM-yyyy HH:mm:ss") : "";
    const to = rawTo ? format(parse(rawTo, INPUT_FORMAT, new Date()), "dd-MM-yyyy HH:mm:ss") : "";
    const satDetails = location.state?.data ? { ...location.state } : JSON.parse(localStorage.getItem('sat_assess_details') || '{}');

    const handleClickTrialButton = async () => {

    };


    const toNumOrNull = (v) => {
        const n = Number(v);
        return v !== null && v !== undefined && v !== '' && !Number.isNaN(n) ? n : null;
    };
    const fmtMarks = (n) => (Number.isInteger(n) ? String(n) : String(+n.toFixed(2)));

    const getMarkingScheme = (assessment) => {
        const positive = toNumOrNull(assessment?.positive_marks);
        if (positive === null) return '';

        const negative = toNumOrNull(assessment?.negative_marks);
        if (negative === null) return `+${fmtMarks(positive)} for Correct`;

        return Math.abs(negative) > 0
            ? `+${fmtMarks(positive)} for Correct, -${fmtMarks(Math.abs(negative))} for Incorrect, 0 for Unattempted`
            : `+${fmtMarks(positive)} for Correct, no negative marking`;
    };

    const buildAssessmentEmailFields = (assessment, totalQuestions) => {
        const syllabus = assessment?.display_config?.syllabus || [];
        return {
            assessment_id: assessment?.id,
            assessment_title: assessment?.title,
            subject_name: assessment?.subject_name || syllabus[0]?.subject || '',
            chapter_name: syllabus[0]?.chapters?.[0]?.chapter || '',
            sections: syllabus.map((s) => s.subject).filter((s) => s && s.length <= 40),
            total_questions: totalQuestions,
            max_marks: assessment?.total_marks,
            duration_minutes: assessment?.time_in_mins,
            marking_scheme: getMarkingScheme(assessment),
            assessment_url: window.location.href,
        };
    };

    const handleStartTest = async (id, index) => {
        if (index === 0 && assessmentdetails1?.is_payment === false) {
            const body = {
                userId: userid,
                planId: assessmentdetails1.subscriptionplanid,
                subscriptionId: assessmentdetails1.subscriptionplanid,
                type: assessmentdetails1?.type,
                id: assessmentdetails1?.title,
                assessmentId: assessmentid,
                firstName: userdetails?.firstName,
                lastName: userdetails?.lastName,
                assessment_type: assessmentdetails1?.assessment_type,
                ...buildAssessmentEmailFields(assessmentdetails1, getQuestionCount(assessmentdetails1)),
            }

            await trialAndStripeSubscriptionService.upgradeFreeSubscription(body)

        }

        setFromIndex(id)
        handleClickTrialButton(view?.assessment_details?.subscriptionplanid, true, view?.assessment_details?.id)
        setComingFrom('start')
        setAssessmentView(true)
        window.scrollTo({ top: 0, behavior: 'instant' })

        if (assessmentdetails1 && assessmentid) {
            localStorage.setItem('sat_assess_details', JSON.stringify({
                assessmentId: assessmentid,
                data: assessmentdetails1
            }));
        }
    }
    const nbsp = '\u00A0';
    const dataTitle = assessmentdetails1?.title
    const hasScheduledAccess = assessmentDetails?.assessmentDetails?.scheduled_from_datetime && assessmentDetails?.assessmentDetails?.scheduled_to_datetime;

    let assessments = [];

    if (hasScheduledAccess && userRole === "AUTH_USER") {
        assessments = [
            { id: 0, title: "Attempt 1", name: `${dataTitle}${nbsp}1` },
        ];
    }

    else if (userRole === 'AUTH_USER') {
        assessments = [
            { id: 0, title: "Attempt 1", name: `${dataTitle}${nbsp}1` },
            { id: 1, title: "Attempt 2", name: `${dataTitle}${nbsp}2` },
            { id: 2, title: "Attempt 3", name: `${dataTitle}${nbsp}3` },
            { id: 3, title: "Attempt 4", name: `${dataTitle}${nbsp}4` },
            { id: 4, title: "Attempt 5", name: `${dataTitle}${nbsp}5` },
            { id: 5, title: "Attempt 6", name: `${dataTitle}${nbsp}6` },
        ];
    }
    else if (isAssessmentFree) {
        assessments = [
            { id: 0, title: "Attempt 1", name: `${dataTitle}${nbsp}1` },
            { id: 1, title: "Attempt 2", name: `${dataTitle}${nbsp}2` },
            { id: 2, title: "Attempt 3", name: `${dataTitle}${nbsp}3` },
            { id: 3, title: "Attempt 4", name: `${dataTitle}${nbsp}4` },
            { id: 4, title: "Attempt 5", name: `${dataTitle}${nbsp}5` },
        ];
    }
    else {
        assessments = [
            { id: 0, title: "Free Attempt", name: `${dataTitle}${nbsp}Free` },
            { id: 1, title: "Attempt 1", name: `${dataTitle}${nbsp}1` },
            { id: 2, title: "Attempt 2", name: `${dataTitle}${nbsp}2` },
            { id: 3, title: "Attempt 3", name: `${dataTitle}${nbsp}3` },
            { id: 4, title: "Attempt 4", name: `${dataTitle}${nbsp}4` },
            { id: 5, title: "Attempt 5", name: `${dataTitle}${nbsp}5` },
        ];
    }

    const completedAssessments = assessments.filter((_, index) => {
        const records = assessmentDetails?.attempts?.[index]?.records || [];
        return records.length > 0 && records[0]?.user_result?.length > 0;
    });


    const handleNavigateSat = () => {

        if (userRole === 'AUTH_USER') {
            navigate("/app/course", { state: assessmentdetails1?.title })
        }
        else {
            navigate(`/auth/subscribe?examId=${assessmentdetails1?.assessment_type_id}`)

        }
    };

    const Clock = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
        </svg>
    );

    const Document = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
        </svg>
    );

    const Graph = ({ size = 24, className = "" }) => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" width={size} height={size} className={className}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0 0 20.25 18V6A2.25 2.25 0 0 0 18 3.75H6A2.25 2.25 0 0 0 3.75 6v12A2.25 2.25 0 0 0 6 20.25Z" />
        </svg>
    );

    const Bolt = () => (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
        </svg>
    );

    const WarningIcon = ({ size = 20 }) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#D946EF" width={size} height={size}>
            <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clipRule="evenodd" />
        </svg>
    );

    const BellIcon = ({ size = 20, className = "" }) => (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width={size} height={size} className={className}>
            <path d="M5.85 3.5a.75.75 0 0 0-1.117-1 9.719 9.719 0 0 0-2.348 4.876.75.75 0 0 0 1.479.248A8.219 8.219 0 0 1 5.85 3.5ZM19.267 2.5a.75.75 0 1 0-1.118 1 8.22 8.22 0 0 1 1.987 4.124.75.75 0 0 0 1.48-.248A9.72 9.72 0 0 0 19.266 2.5Z" />
            <path fillRule="evenodd" clipRule="evenodd" d="M12 2.25A6.75 6.75 0 0 0 5.25 9v.75a8.217 8.217 0 0 1-2.119 5.52.75.75 0 0 0 .298 1.206c1.544.57 3.16.99 4.831 1.243a3.75 3.75 0 1 0 7.48 0 24.583 24.583 0 0 0 4.83-1.244.75.75 0 0 0 .298-1.205 8.217 8.217 0 0 1-2.118-5.52V9A6.75 6.75 0 0 0 12 2.25ZM9.75 18c0-.034 0-.067.002-.1a25.05 25.05 0 0 0 4.496 0l.002.1a2.25 2.25 0 1 1-4.5 0Z" />
        </svg>
    );


    const handleAssessmentTabChange = (newValue) => {
        setAssessmentTabIndex(newValue);
        window.scrollTo({ top: 0, behavior: 'instant' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    };

    const isSubscriptionExpired = (validFrom, validTo) => {
        if (!validFrom || !validTo) return false;
        const today = new Date();
        const fromDate = new Date(validFrom);
        const toDate = new Date(validTo);
        const expiredDate = today < fromDate || today > toDate;
        return expiredDate;
    };

    const subscriptionExpired = isSubscriptionExpired(assessmentdetails1?.valid_from, assessmentdetails1?.valid_to);
    const currentDate = new Date()
    const isExpired = new Date(assessmentdetails1?.valid_to) > currentDate

    const onCallBack = (id, assessment, refresh) => {
        setAssessmentId(id)
        setAssessmentDetails1(assessment)
        setAssessmentView(false)

        localStorage.setItem('sat_assess_details', JSON.stringify({
            assessmentId: id,
            data: assessment
        }));

        if (refresh) {
            loadInitialData();
        }
    }


    const AccordionItem = ({ index, subject, chapters }) => {
        const [open, setOpen] = useState(false);

        return (
            <div className="border border-gray-200 rounded-lg mb-2">
                <button
                    onClick={() => setOpen(!open)}
                    className="w-full flex items-start justify-between px-4 py-3 text-left"
                >
                    <div className="flex items-start gap-3 flex-1 min-w-0">
                        <div className="min-w-[24px] h-6 rounded bg-gray-200 flex items-center justify-center text-sm font-semibold text-gray-500 flex-shrink-0 mt-0.5">
                            {index}
                        </div>
                        <span className="text-sm font-medium text-gray-900 text-left break-words">
                            {subject}
                        </span>
                    </div>
                    <ChevronDown
                        className={`w-4 h-4 text-gray-500 transition-transform flex-shrink-0 ml-2 mt-1 ${open ? "rotate-180" : ""}`}
                    />
                </button>

                {open && (
                    <div className="px-4 pb-3 pl-12">
                        <ul className="list-disc space-y-1 text-sm text-gray-600 text-left">
                            {chapters?.map((chapterObj, i) => (
                                <li key={i} className="text-left break-words">
                                    {chapterObj.chapter}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        );
    };


    React.useEffect(() => {
        const format = "DD/MM/YYYY hh:mm:ss A";

        const checkWindow = () => {
            const fromDate = dayjs(assessmentdetails1?.user_message?.fromDate, format);
            const toDate = dayjs(assessmentdetails1?.user_message?.toDate, format);

            if (!fromDate.isValid() || !toDate.isValid()) {
                setMaintainanceView(false);
                return;
            }

            setMaintainanceView(dayjs().isBetween(fromDate, toDate, null, "[]"));
        };

        checkWindow();
        const interval = setInterval(checkWindow, 30000); // re-check every 30s

        return () => clearInterval(interval);
    }, [assessmentdetails1]);

    const attemptsLen = assessmentDetails?.attempts?.length || 0;
    const maxAttempts = (isAssessmentFree && userRole !== 'AUTH_USER') ? 5 : 6;

    const buttonText = attemptsLen === 0 ? "Start Test"
        : (attemptsLen >= maxAttempts ||
            (hasScheduledAccess && userRole === "AUTH_USER"))
            ? "View Analytics"
            : "Continue Test";


    const formatDuration = (mins) => {
        if (!mins && mins !== 0) return "-";

        const hours = Math.floor(mins / 60);
        const minutes = mins % 60;


        if (hours === 0) return `${minutes} min`;
        if (minutes === 0) return `${hours} hr`;

        return `${hours} hr ${minutes} min`;
    };

    const getLinearTotalQuestions = (assessment) => {
        if (!assessment?.section_details) return 0;

        return assessment.section_details.reduce((total, section) => {
            return total + Number(section.questionperattempt || 0);
        }, 0);
    };

    const getQuestionCount = (a) => {
        if (!a) return 0;
        if (a.assessment_pattern_name === "Linear") return getLinearTotalQuestions(a);
        if (a.assessment_type === "Full Test") return 98;
        if (a.assessment_type === "English Subject Test" && a.assessment_sub_type_id === 13) return 54;
        return 44;
    };


    useEffect(() => {
        getAnalysis(fromIndex);
        getAnalysisTestScore(fromIndex, assessmentdetails1?.assessment_pattern_name)
    }, [])

    const getAnalysisTestScore = async (index, type) => {
        const result = await adminServices.getAnalysisTestScore(assessmentid, userid, index, type)
        if (result.ok) {
            setAnalysisTestScore(result.data)
        }
    }

    const getAnalysis = async (index) => {
        setIsLoading(true)
        const result = await adminServices.getAdaptiveAssessmentAnalysis(assessmentid, userid, index, assessmentdetails1?.assessment_pattern_name, name)
        if (result.ok) {
            setAllQuestions(result.data?.sectional_details && result.data?.sectional_details?.length > 0 && result.data?.sectional_details[0]?.questions)
            setAnalysis(result.data.sectional_details)
            setChapterMastery(result.data?.chapter_mastery)
            setvisibleTabs(result.data?.assessment_modules)
            setIsLoading(false)
        }
    }

    const ViewAnalysis = (index) => {
        setSelectedAttemptIndex(index);
        setAssessmentTabIndex(2);
        setFromIndex(index)
        getAnalysis(index);
        getAnalysisTestScore(fromIndex, assessmentdetails1?.assessment_pattern_name)
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    const TabValueChange = () => {
        setAssessmentTabIndex(1)
    }

    const StartButtonContent = ({ fullWidth = false }) => {
        const firstEmptyAssessmentIndex = assessments.findIndex((_, i) => {
            const results = assessmentDetails?.attempts?.[i]?.records || [];
            return results.length === 0;
        });

        if (assessmentdetails1?.ispaid) {
            if (subscriptionExpired) {
                return (
                    <button
                        type="button"
                        onClick={() =>
                            navigate(
                                userRole === 'AUTH_USER' ? '/app/plans' : '/auth/plans',
                                { state: { satDetails: location.state?.allSatDetails, returnPath: location.pathname } }
                            )
                        }
                        className={`${fullWidth ? 'w-full' : 'w-full'} bg-red-500 hover:bg-red-600 text-white py-3 rounded-md text-sm font-semibold transition-all`}
                    >
                        Renew Assessment
                    </button>
                );
            }
            return (
                <button
                    onClick={() => TabValueChange()}
                    className={`${fullWidth ? 'w-full' : 'w-full'} bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold transition-all flex items-center justify-center gap-2`}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                        <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
                    </svg>
                    {buttonText}
                </button>
            );
        }

        return (
            <>
                <button
                    onClick={() => TabValueChange()}
                    disabled={isLoading}
                    className={`${fullWidth ? 'w-full' : 'w-full'} bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg text-sm font-semibold transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed`}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
                        <path fillRule="evenodd" d="M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z" clipRule="evenodd" />
                    </svg>
                    {/* {isLoading ? 'Please wait...' : assessmentDetails?.attempts?.length === 0 ? 'Take Free Test' : (hasScheduledAccess && userRole === "AUTH_USER" ? "View Analytics" :"Continue Test")} */}
                    {buttonText}
                </button>
                {userRole === 'USER_DTC' && (
                    <p className="text-center text-xs text-gray-500 mt-2">
                        Want full access?{" "}
                        <button
                            type="button"
                            onClick={() =>
                                navigate(
                                    userRole === 'AUTH_USER' ? '/app/plans' : '/auth/plans',
                                    { state: { satDetails: location.state?.allSatDetails, returnPath: location.pathname } }
                                )
                            }
                            className="text-blue-600 font-semibold hover:underline bg-transparent border-none cursor-pointer p-0"
                        >
                            Upgrade to Access →
                        </button>
                    </p>
                )}
            </>
        );
    };

    const bannerImage = assessmentdetails1?.assessment_type === "Full Test"
        ? fullCover
        : assessmentdetails1?.assessment_type === "English Subject Test" ||
            assessmentdetails1?.assessment_type === "Maths Subject Test"
            ? subjectCover
            : subjectCover;

    const tabLabels = ["Overview", "My Attempts", "My Performance"];

    // Attempts that were actually submitted (the API pre-fills empty slots).
    const completedAttemptIdx = (assessmentDetails?.attempts || [])
        .map((a, i) => ((a?.records?.[0]?.user_result?.length ?? 0) > 0 ? i : -1))
        .filter((i) => i >= 0);
    const lastCompletedAttempt = completedAttemptIdx.length ? completedAttemptIdx[completedAttemptIdx.length - 1] : -1;
    const flashcardAttempt = completedAttemptIdx.includes(selectedAttemptIndex) && assessmentTabIndex === 2
        ? selectedAttemptIndex
        : lastCompletedAttempt;

    return (
        <>
            {pageLoading ? (
                <AssessmentSkeleton />
            ) : (
                <>
                    {assessmentView === false && (
                        <Box sx={{ width: '100%', backgroundColor: "white", marginTop: { xs: '52px', md: '56px' } }}>


                            <div className="px-4 md:px-6 pt-4 pb-3">
                                <button
                                    onClick={handleNavigateSat}
                                    className="text-sm flex items-center gap-2 text-gray-500 hover:text-gray-900 transition-colors"
                                >
                                    <span className="text-base leading-none">‹</span>
                                    <span>Back to Catalog</span>
                                </button>
                            </div>

                            <div className="relative overflow-hidden rounded-xl mx-4 md:mx-6" style={{ height: '200px' }}>
                                <img
                                    src={bannerImage}
                                    alt="Assessment Cover"
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/50" />

                                <div className="absolute inset-0 flex flex-col justify-end px-4 md:px-14 py-5">
                                    <div className="text-white max-w-full md:max-w-[90%]">
                                        <h1 className="text-base md:text-3xl font-bold leading-tight line-clamp-3">
                                            {assessmentdetails1?.title}
                                        </h1>

                                        <div className="mt-2 min-h-[40px] md:min-h-[56px]">
                                            {assessmentdetails1?.short_description ? (
                                                <p
                                                    className="text-sm md:text-base opacity-90 line-clamp-2 [&_*]:!text-white"
                                                    dangerouslySetInnerHTML={{
                                                        __html: assessmentdetails1.short_description,
                                                    }}
                                                />
                                            ) : (
                                                <div />
                                            )}
                                        </div>

                                        {assessmentdetails1?.assessment_type && (
                                            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white/20 text-white border border-white/30 backdrop-blur-sm mt-2">
                                                {assessmentdetails1?.subject_name ||
                                                    assessmentdetails1?.category_name ||
                                                    assessmentdetails1?.assessment_type}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {subscriptionExpired && (
                                <div className="w-full bg-red-500 px-4 py-3 text-white font-medium flex items-center gap-3">
                                    <div className="flex items-center justify-center ml-9">
                                        <BellIcon size={20} className="text-white" />
                                    </div>
                                    <div>
                                        <p className="font-semibold">Your Assessment Subscription has expired. You can renew this assessment from the <b>Overview</b> tab.</p>
                                        <p className="text-xs">Access to this Assessment ended on date. You can renew the assessment from the 'Overview' tab.</p>
                                    </div>
                                </div>
                            )}
                            {attemptsLen >= maxAttempts && !subscriptionExpired && (
                                <div className="w-full bg-[#fdf1ff] px-4 sm:px-6 py-4 flex items-start gap-3">
                                    <div className="flex-shrink-0 pt-0.5">
                                        <WarningIcon />
                                    </div>

                                    <div className="text-left">
                                        <p className="font-semibold leading-tight text-black">
                                            All attempts completed!
                                        </p>

                                        <p className="text-xs text-gray-700 mt-1">
                                            {userRole === 'AUTH_USER' ? (
                                                <>
                                                    You've used all 6 attempts for this assessment.
                                                </>
                                            ) : (
                                                isAssessmentFree ?
                                                    <>You've used all 5 attempts for this assessment.</>

                                                    :

                                                    <>
                                                        You've used all 6 attempts for this assessment. Purchase again
                                                        from the <b>Overview</b> tab to get 5 more (+1 free) attempts
                                                        and continue practicing.
                                                    </>
                                            )}
                                        </p>
                                    </div>
                                </div>
                            )}

                            <Box sx={{ ml: { xs: '16px', md: '24px' }, mr: { xs: '16px', md: '24px' }, marginTop: '20px' }}>

                                <div className="mt-4 mb-4 w-full">
                                    <div className="grid grid-cols-3 gap-2 md:gap-0 bg-gray-100 rounded-xl p-1 w-full md:w-fit">
                                        {tabLabels.map((label, index) => (
                                            <button
                                                key={index}
                                                onClick={() => handleAssessmentTabChange(index)}
                                                className={`
          flex items-center justify-center whitespace-nowrap
          h-10 px-3 md:px-6
          text-xs sm:text-sm md:text-base
          rounded-md transition-all duration-200
          ${assessmentTabIndex === index
                                                        ? "bg-white shadow-sm text-black border border-gray-200 font-medium"
                                                        : "text-gray-500 hover:text-black"}
        `}
                                            >
                                                {label}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                            </Box>{/* close width:92% tabs Box */}

                            <Box sx={{ ml: { xs: '16px', md: '24px' }, mr: { xs: '16px', md: '24px' }, paddingBottom: '40px' }}>

                                {/* ── OVERVIEW TAB ─────────────────────────────────── */}
                                {assessmentTabIndex === 0 && (
                                    <div className="w-full pb-6">
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full items-start">

                                            <div className="md:col-span-2 space-y-6">

                                                {assessmentdetails1?.assessment_pattern_name === 'Linear' && (
                                                    <div className="md:col-span-2 min-w-0">
                                                        <AssessmentScore
                                                            part="chart"
                                                            data={analysisTestScore}
                                                            selectedAttemptIndex={fromIndex}
                                                            details={getQuestionCount(assessmentdetails1)}
                                                            maxAttempts={maxAttempts}
                                                            assessmentdetails1={assessmentdetails1}
                                                            hasScheduledAccess={hasScheduledAccess}
                                                        />
                                                    </div>
                                                )}

                                                {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                    <div className="md:col-span-2 min-w-0">
                                                        <ScoreProgression
                                                            analysis={analysisTestScore}
                                                            selectedAttemptIndex={fromIndex}
                                                            assessmentdetails1={assessmentdetails1}
                                                            userRole={userRole}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className="hidden md:block self-start">
                                                <div className="border border-gray-200 rounded-xl bg-white shadow-sm sticky top-6">
                                                    <div className="px-5 pt-5 pb-3 border-b border-gray-100">
                                                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                                                            Test Series Details
                                                        </p>
                                                    </div>

                                                    <div className="px-5 py-4 space-y-4">
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-8 h-8 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#F97316" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Duration</p>
                                                                <p className="text-sm font-semibold text-gray-800">{formatDuration(assessmentdetails1?.time_in_mins)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#3B82F6" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Questions</p>
                                                                <p className="text-sm font-semibold text-gray-800">{getQuestionCount(assessmentdetails1)} Qs</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-8 h-8 rounded-full bg-yellow-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#EAB308" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.563.563 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Total Marks</p>
                                                                <p className="text-sm font-semibold text-gray-800">{assessmentdetails1?.total_marks || 0} Marks</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3">
                                                            <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#A855F7" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Section Lock</p>
                                                                <p className="text-sm font-semibold text-gray-800">{assessmentdetails1?.allownavigation ? 'Free Navigation' : 'Navigation'}</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="border-t border-gray-100 mx-5" />
                                                    <div className="px-5 py-4">
                                                        {assessmentdetails1?.ispaid && subscriptionExpired ? (
                                                            <>
                                                                <div className="mb-3">
                                                                    <p className="text-xs text-gray-400 mb-1">Attempts Completed</p>
                                                                    <p className="text-3xl font-bold text-blue-600">
                                                                        {assessmentDetails?.attempts?.length || 0}/5
                                                                    </p>
                                                                </div>
                                                                <StartButtonContent />
                                                            </>
                                                        ) : (
                                                            <StartButtonContent />
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="md:hidden space-y-3">
                                                <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
                                                    <div className="px-5 pt-5 pb-3 border-b border-gray-100">
                                                        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">
                                                            Assessment Details
                                                        </p>
                                                    </div>

                                                    <div className="px-5 divide-y divide-gray-100">
                                                        <div className="flex items-center gap-3 py-3.5">
                                                            <div className="w-8 h-8 rounded-full bg-orange-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#F97316" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Duration</p>
                                                                <p className="text-sm font-semibold text-gray-800">{formatDuration(assessmentdetails1?.time_in_mins)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3 py-3.5">
                                                            <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#3B82F6" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 5.25h.008v.008H12v-.008Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Questions</p>
                                                                <p className="text-sm font-semibold text-gray-800">{getQuestionCount(assessmentdetails1)} Qs</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3 py-3.5">
                                                            <div className="w-8 h-8 rounded-full bg-yellow-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#EAB308" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.563.563 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Total Marks</p>
                                                                <p className="text-sm font-semibold text-gray-800">{assessmentdetails1?.total_marks || 0} Marks</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-3 py-3.5">
                                                            <div className="w-8 h-8 rounded-full bg-purple-50 flex items-center justify-center flex-shrink-0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#A855F7" className="w-4 h-4">
                                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-[10px] text-gray-400 uppercase tracking-wide font-medium">Section Lock</p>
                                                                <p className="text-sm font-semibold text-gray-800">{assessmentdetails1?.allownavigation ? 'Free Navigation' : 'Navigation'}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div className="md:hidden fixed bottom-[64px] left-0 right-0 z-40 bg-white border-t border-gray-100 px-4 pt-3 pb-[calc(env(safe-area-inset-bottom)+12px)] shadow-[0_-4px_12px_rgba(0,0,0,0.06)]">
                                                {assessmentdetails1?.ispaid && subscriptionExpired ? (
                                                    <>
                                                        <div className="mb-2">
                                                            <p className="text-xs text-gray-400 mb-1">Attempts Completed</p>
                                                            <p className="text-2xl font-bold text-blue-600">
                                                                {assessmentDetails?.attempts?.length || 0}/5
                                                            </p>
                                                        </div>
                                                        <StartButtonContent fullWidth />
                                                    </>
                                                ) : (
                                                    <StartButtonContent fullWidth />
                                                )}
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 md:mt-6 items-start">

                                            <div className="border border-gray-200 rounded-2xl p-6 bg-white shadow-sm min-w-0">
                                                <h2 className="text-lg font-semibold mb-3 flex items-center gap-3 text-gray-900">
                                                    <span>🔶</span>
                                                    <span>What's inside this learning block?</span>
                                                </h2>

                                                {assessmentdetails1?.description && (
                                                    <p
                                                        className="text-sm text-gray-600 mb-4 [&_*]:text-gray-600"
                                                        dangerouslySetInnerHTML={{ __html: assessmentdetails1?.description || "" }}
                                                    />
                                                )}

                                                {assessmentdetails1?.display_config?.bullets &&
                                                    assessmentdetails1?.display_config?.bullets?.length > 0 && (
                                                        <div className="flex flex-col gap-2">
                                                            {assessmentdetails1?.display_config?.bullets?.map((bullet, index) => (
                                                                <div key={index} className="flex items-start gap-2 text-sm text-gray-700">
                                                                    <CheckCircleIcon className="w-4 h-4 text-[#10B981] mt-0.5 flex-shrink-0" />
                                                                    <span>{bullet}</span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                            </div>

                                            <div className="border border-gray-200 rounded-2xl bg-white shadow-sm overflow-hidden min-w-0">
                                                <button
                                                    onClick={() => setSyllabusOpen(!syllabusOpen)}
                                                    className="w-full flex items-start justify-between px-6 py-5 hover:bg-gray-50 transition-colors"
                                                >
                                                    <div className="text-left">
                                                        <h2 className="text-lg font-semibold text-gray-900">
                                                            {syllabusOpen ? "Topics Covered" : "Syllabus & Included Chapters"}
                                                        </h2>
                                                        {!syllabusOpen && (
                                                            <p className="text-xs text-[#10B981] mt-1">
                                                                Expand a chapter sub-block below to review specific focus topics covered in test questions.
                                                            </p>
                                                        )}
                                                    </div>
                                                    <ChevronDown
                                                        className={`w-5 h-5 text-gray-400 transition-transform flex-shrink-0 ml-4 mt-1 ${syllabusOpen ? "rotate-180" : ""}`}
                                                    />
                                                </button>

                                                {syllabusOpen && (
                                                    <div className="px-6 pb-5 space-y-2">
                                                        {assessmentdetails1?.display_config?.syllabus &&
                                                            assessmentdetails1?.display_config?.syllabus?.map((item, index) => (
                                                                <AccordionItem
                                                                    key={index}
                                                                    index={index + 1}
                                                                    subject={item.subject}
                                                                    chapters={item.chapters}
                                                                />
                                                            ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {assessmentTabIndex === 1 && maintainanceView === false && (
                                    <div id="box1" className="flex flex-col gap-6 p-4 sm:p-4 md:p-4 bg-white rounded-xl border border-gray-200">
                                        <div id="box2" className="flex flex-col gap-6">
                                            <h2 className="text-2xl font-semibold">Your Attempts</h2>
                                            {assessments && assessments?.length > 0 && assessments?.map((assessment, index) => {
                                                let borderColor = '';
                                                let Color = '';
                                                const scoreDatanew = assessmentDetails?.attempts[index];
                                                const attemptscore = (assessmentDetails?.scoreProgression || [])
                                                const getScore = () => {
                                                    return attemptscore?.[index]?.totalScore ??
                                                        (assessmentDetails?.attempts?.[index]?.records?.[0]?.user_result?.length > 0 ? 0 : 'NA');
                                                };

                                                if (assessmentDetails && assessmentDetails?.attempts?.length > 0 && assessmentDetails?.attempts[index]?.records &&
                                                    assessmentDetails?.attempts[index]?.records?.filter(item => item.response_recorded === "correct" && item.response_recorded !== "incorrect")?.length === assessmentDetails[index]?.records?.length) {
                                                    borderColor = '#40C057'; Color = '#EAFBEA';
                                                } else if (assessmentDetails && assessmentDetails?.attempts?.length > 0 && assessmentDetails?.attempts[index]?.records &&
                                                    assessmentDetails?.attempts[index]?.records?.filter(item => item.response_recorded === "incorrect" || "correct")?.length === assessmentDetails?.attempts[index]?.records?.length) {
                                                    borderColor = '#FA5252'; Color = '#FCEBEA';
                                                } else {
                                                    borderColor = '#dddada'; Color = '#f5f5f5';
                                                }

                                                const firstEmptyAssessmentIndex = assessments.findIndex((_, i) => {
                                                    const results = assessmentDetails?.attempts?.[i]?.records || [];
                                                    return results.length === 0;
                                                });

                                                const isStartDisabled =
                                                    (userRole === 'AUTH_USER' || assessmentdetails1?.is_payment === false)
                                                        ? (index > 0 && (assessmentDetails?.attempts?.[index - 1]?.records?.[0]?.user_result?.length ?? 0) < 1)
                                                        : (
                                                            ((assessmentdetails1?.ispaid !== true && assessmentdetails1?.is_payment !== null && assessmentdetails1?.is_payment !== false) ||
                                                                subscriptionExpired || assessmentdetails1?.ispaid === false)
                                                                ? index !== 0
                                                                : (assessmentdetails1?.is_payment === false)
                                                                    ? (index > 0 && (assessmentDetails?.attempts?.[index - 1]?.records?.[0]?.user_result?.length ?? 0) < 1)
                                                                    : (firstEmptyAssessmentIndex !== index || (index > 0 && (assessmentDetails?.attempts?.[index - 1]?.records?.[0]?.user_result?.length ?? 0) < 1))
                                                        );

                                                return (
                                                    <Box key={assessment.id} id="boxInner" sx={{ borderRadius: "4px", width: '99%', padding: '10px !important', height: 'auto', backgroundColor: '#EEEEEE', flexWrap: "wrap" }}>
                                                        <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row', md: 'row' }, justifyContent: "space-between", padding: '8px 15px ', alignItems: { xs: 'left', sm: 'center', md: 'center' } }}>
                                                            <Box sx={{ flex: 1, gap: 2 }}>
                                                                <div className="grid grid-cols-[auto_1fr_auto] items-center gap-4 mb-1">
                                                                    <span className="font-semibold text-[14px] md:text-[16px] w-[130px]">{assessment?.title}</span>
                                                                    {assessmentDetails?.attempts[index]?.records[0]?.user_result?.length > 0 && (
                                                                        <span className="flex items-center gap-1 text-[12px] font-medium text-green-600 justify-self-start">
                                                                            <span className="w-1.5 h-1.5 rounded-full bg-green-600" />
                                                                            Completed
                                                                        </span>
                                                                    )}
                                                                </div>
                                                                <Box sx={{ display: 'flex', alignItems: { xs: 'left', sm: 'center', md: 'center' }, gap: { xs: 0.5, sm: 2, md: 2 }, color: '#666', flexDirection: { xs: 'column', sm: 'row', md: 'row' } }}>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <HelpOutlineIcon sx={{ fontSize: '16px' }} />
                                                                        <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}>{getQuestionCount(assessmentdetails1)}</Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <Graph size={18} />
                                                                        <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}>Score: <b>{getScore()}</b></Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                                        <AccessTimeIcon sx={{ fontSize: '16px' }} />
                                                                        <Typography variant="body2" sx={{ fontSize: { xs: 12, sm: 14, md: 16 } }}>{`${assessmentdetails1?.time_in_mins} mins`}</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                            {assessmentDetails?.attempts && assessmentDetails?.attempts[index]?.records && assessmentDetails?.attempts[index]?.records?.length > 0 ? (
                                                                <>
                                                                    {assessmentDetails?.attempts[index]?.records[0]?.user_result?.length > 0 && (
                                                                        <button onClick={() => ViewAnalysis(index)} className="w-full sm:w-auto px-4 py-2 text-sm font-medium rounded-md border border-blue-500 text-blue-500 transition-all duration-200">
                                                                            View Analysis
                                                                        </button>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <Tooltip title={
                                                                    subscriptionExpired
                                                                        ? "Your subscription has expired. Please renew to access this assessment."
                                                                        : (assessmentdetails1?.is_payment === true && assessmentdetails1?.ispaid !== true && userRole !== "AUTH_USER") ||
                                                                            subscriptionExpired ||
                                                                            (assessmentdetails1?.is_payment === true && assessmentdetails1?.ispaid === false)
                                                                            ? (index === 0 ? "Click to start your free test" : "Please purchase this test to access the attempts!")
                                                                            : (firstEmptyAssessmentIndex !== index || (index > 0 && assessmentDetails?.attempts[index - 1]?.records?.[0]?.user_result?.length === 0))
                                                                                ? "Please complete the previous test to access this attempts!"
                                                                                : "Click to start the test"
                                                                }>
                                                                    <Box sx={{ display: 'inline-block', width: { xs: '100%', sm: 'auto' } }}>
                                                                        <button
                                                                            onClick={() => !subscriptionExpired && handleStartTest(assessment?.id, index)}
                                                                            disabled={isStartDisabled || subscriptionExpired}
                                                                            className={`w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium rounded-md border transition-all duration-200 ${isStartDisabled || subscriptionExpired ? "border-gray-300 bg-gray-300 text-white cursor-not-allowed" : "border-blue-500 text-white bg-blue-500"}`}
                                                                        >
                                                                            {(subscriptionExpired || (userRole !== "AUTH_USER" && (
                                                                                ((assessmentdetails1?.is_payment === true && assessmentdetails1?.ispaid === false && userRole !== "AUTH_USER") || subscriptionExpired || assessmentdetails1?.ispaid === false)
                                                                                    ? index !== 0
                                                                                    : (assessmentdetails1?.ispaid === true && assessmentdetails1?.is_payment === true) || (assessmentdetails1?.is_payment === false && assessmentdetails1?.ispaid === false)
                                                                                        ? false
                                                                                        : (firstEmptyAssessmentIndex !== index || (index > 0 && assessmentDetails?.attempts?.[index - 1]?.records?.[0]?.user_result?.length < (assessmentdetails1?.assessment_type !== "Full Test" ? 2 : 4)) || subscriptionExpired || assessmentdetails1?.ispaid === false)
                                                                            ))) && (assessmentdetails1?.is_payment === false ? "" : <LockOutlinedIcon sx={{ fontSize: 18 }} />)}
                                                                            Start Now
                                                                        </button>
                                                                    </Box>
                                                                </Tooltip>
                                                            )}
                                                        </Box>
                                                    </Box>
                                                );
                                            })}
                                        </div>
                                    </div>

                                )}
                                {assessmentTabIndex === 2 && maintainanceView === false && (
                                    <>
                                        {isLoading ? (
                                            <AnalyticsSkeleton />
                                        ) : (
                                            <div className="w-full">
                                                {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                    <div className="flex justify-between items-center mb-4">
                                                        <AttemptDropdown
                                                            assessments={completedAssessments}
                                                            selectedAttemptIndex={selectedAttemptIndex}
                                                            onSelect={(newIndex) => {
                                                                getAnalysis(newIndex);
                                                                setSelectedAttemptIndex(newIndex);
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">

                                                    {assessmentdetails1?.assessment_pattern_name === 'Linear' && (
                                                        <div className="md:col-span-2 min-w-0" id="assessment-score-box">
                                                            <AssessmentScore
                                                                part="stats"
                                                                data={analysisTestScore}
                                                                selectedAttemptIndex={fromIndex}
                                                                details={getQuestionCount(assessmentdetails1)}
                                                                maxAttempts={maxAttempts}
                                                                assessmentdetails1={assessmentdetails1}
                                                                hasScheduledAccess={hasScheduledAccess}
                                                            />
                                                        </div>
                                                    )}



                                                    <div className="md:col-span-2 min-w-0" ref={questionAnalysisRef}>
                                                        <QuestionWiseAnalysis
                                                            activeTabs={activeTabs}
                                                            handleTabChangeTabs={handleTabChangeTabs}
                                                            visibleTabs={visibleTabs}
                                                            allQuestions={allQuestions}
                                                        />
                                                    </div>

                                                    {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                        <div className="md:col-span-2 min-w-0" id="box">
                                                            <PacingAnalysis analysis={analysis} selectedAttemptIndex={fromIndex} />
                                                        </div>
                                                    )}

                                                    <div className="min-w-0">
                                                        <ChapterMastery
                                                            activeTabs={activeTabs}
                                                            data={chapterMastery ? chapterMastery : []}
                                                            selectedAttemptIndex={fromIndex}
                                                        />
                                                    </div>

                                                    <div className="min-w-0 flex flex-col bg-white rounded-2xl border border-gray-200 p-4 sm:p-6" id="sectional-summary-box">
                                                        <div style={{ marginBottom: 20 }}>
                                                            <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: "#111827", letterSpacing: "-0.3px" }}>
                                                                How Did You Do in Each Section ?
                                                            </h2>
                                                            <p style={{ margin: "4px 0 0", fontSize: 13, color: "#6B7280" }}>
                                                                Compare your performance across different Sections
                                                            </p>
                                                        </div>

                                                        <div className="flex-1 min-h-0 overflow-y-auto">
                                                            <ScoreCardAnalytics analysis={analysis} selectedAttemptIndex={fromIndex} />
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                                {/* {assessmentTabIndex === 2 && maintainanceView === false && (
                                    <>
                                        {isLoading ? (
                                            <AnalyticsSkeleton />
                                        ) : (
                                            <div className="w-full">
                                                {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                    <div className="flex justify-between items-center mb-4">
                                                        <AttemptDropdown
                                                            assessments={completedAssessments}
                                                            selectedAttemptIndex={selectedAttemptIndex}
                                                            onSelect={(newIndex) => {
                                                                getAnalysis(newIndex);
                                                                setSelectedAttemptIndex(newIndex);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                                <>
                                                  
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: { xs: 'column', md: 'row' },
                                                            alignItems: 'stretch',
                                                            gap: 3,
                                                            mb: 3,
                                                        }}
                                                    >
                                                        {assessmentdetails1?.assessment_pattern_name === 'Linear' && (
                                                            <Box sx={{ flex: { md: '1 1 50%' }, width: { xs: '100%', md: '50%' } }} id="assessment-score-box">
                                                                <AssessmentScore
                                                                    data={analysisTestScore}
                                                                    selectedAttemptIndex={fromIndex}
                                                                    details={getQuestionCount(assessmentdetails1)}
                                                                    maxAttempts={maxAttempts}
                                                                    assessmentdetails1={assessmentdetails1}
                                                                    hasScheduledAccess={hasScheduledAccess}
                                                                />
                                                            </Box>
                                                        )}

                                                        {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                            <Box sx={{ flex: { md: '1 1 50%' }, width: { xs: '100%', md: '50%' } }} id="assessment-score-box">
                                                                <ScoreProgression
                                                                    analysis={analysisTestScore}
                                                                    selectedAttemptIndex={fromIndex}
                                                                    assessmentdetails1={assessmentdetails1}
                                                                    userRole={userRole}
                                                                />
                                                            </Box>
                                                        )}

                                                        <Box
                                                            sx={{
                                                                flex: { md: '1 1 50%' },
                                                                width: { xs: '100%', md: '50%' },
                                                                mt: { xs: 0, md: 0 },
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                            }}
                                                            id="sectional-summary-box"
                                                        >
                                                            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: 14, sm: 32, md: 32 }, mt: 1 }}>
                                                                Sectional Summary
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ mb: 3, fontWeight: 500, color: '#595959', fontSize: { xs: 10, sm: 16, md: 16 } }}>
                                                                Review your results for each module and section evaluated with our diagnostic assessments
                                                            </Typography>
                                                            <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                                                                <ScoreCardAnalytics analysis={analysis} selectedAttemptIndex={fromIndex} />
                                                            </Box>
                                                        </Box>
                                                    </Box>

                                                    <Box sx={{ mt: 2, mb: 2 }} ref={questionAnalysisRef}>
                                                        <Box item xs={12} md={6}>
                                                            <QuestionWiseAnalysis activeTabs={activeTabs} handleTabChangeTabs={handleTabChangeTabs} visibleTabs={visibleTabs} allQuestions={allQuestions} />
                                                        </Box>
                                                    </Box>


                                                    {assessmentdetails1?.assessment_pattern_name === 'Adaptive' && (
                                                        <Box sx={{ mb: 3 }} id='box'>
                                                            <PacingAnalysis analysis={analysis} selectedAttemptIndex={fromIndex} />
                                                        </Box>
                                                    )}
                                                    <Box sx={{ mt: 2, mb: 2 }} ref={questionAnalysisRef}>
                                                        <Box item xs={12} md={6}>
                                                            <ChapterMastery activeTabs={activeTabs} data={chapterMastery ? chapterMastery : []} selectedAttemptIndex={fromIndex} />
                                                        </Box>
                                                    </Box>

                                                </>
                                            </div>
                                        )}
                                    </>
                                )} */}

                                {((assessmentTabIndex === 1 || assessmentTabIndex === 2) && maintainanceView === true && assessmentTabIndex !== 0) && (
                                    <div className="bg-white border border-gray-200 rounded-xl p-8 shadow-sm flex flex-col items-center justify-center text-center gap-4">
                                        <img src={assessmentMaintainance} alt="Under Maintenance" className="w-52 h-auto" />
                                        <h2 className="text-lg font-semibold text-gray-800">This Assessment is under maintenance</h2>
                                        <p className="text-sm text-gray-500 max-w-md">
                                            We have scheduled a maintenance till {assessmentdetails1?.user_message?.toDate}. We request you to please bear with us. Thank you!
                                        </p>
                                    </div>
                                )}
                            </Box>
                        </Box>
                    )}

                    {assessmentView === true && (assessmentdetails1?.is_published === true || assessmentdetails1?.status_type === 1 || maintainanceView === false) && (
                        assessmentdetails1?.assessment_pattern_name === 'Linear'
                            ? <LinearAssessment assessmentId={assessmentid} comingFrom={comingFrom} fromIndex={fromIndex} details={assessmentdetails1} onCallBack={onCallBack} resumeData={resumeData} resumeLength={resumeLength} assessmenttitle={assessmentdetails1?.title} CallBackAssessmentView={CallBackAssessmentView} />
                            : <AdaptiveAssessment assessmentId={assessmentid} comingFrom={comingFrom} fromIndex={fromIndex} details={assessmentdetails1} onCallBack={onCallBack} resumeData={resumeData} resumeLength={resumeLength} assessmenttitle={assessmentdetails1?.title} CallBackAssessmentView={CallBackAssessmentView} />
                    )}
                </>
            )}

            {!pageLoading && assessmentView === false && assessmentid && process.env.REACT_APP_ENV === 'dev' && (
                <FlashcardFab
                    assessmentId={Number(assessmentid)}
                    assessmentTitle={assessmentdetails1?.title}
                    attemptsMade={lastCompletedAttempt + 1}
                    attemptIndex={flashcardAttempt}
                />
            )}

            {/* <AssessmentCompleteDialog
                open={showExamCompleteDialog}
                assessmentId={assessmentid}
                onViewAnalytics={() => { setShowExamCompleteDialog(false); setAssessmentView(false); setAssessmentTabIndex(2); }}
                onClose={() => setShowExamCompleteDialog(false)}
            /> */}
        </>
    );
};

export default AssessmentOverview;

const useStyles = makeStyles(() => ({
    greetingCard: {
        width: '100%',
        backgroundColor: '#d2daff',
        borderRadius: '18px'

    }
}));